import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PrivacyPolicy = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>Privacy Policy – Naijads.ng</title>
        <meta
          name="description"
          content="See how Naijads.ng collects, uses, and protects your personal data under Nigerian law. We respect your privacy and keep your info safe."
        />
        <link rel="canonical" href="https://naijads.ng/privacy-policy" />
        <meta property="og:title" content="Privacy policy – Naijads.ng" />
        <meta
          property="og:description"
          content="Learn what data Naijads.ng collects and how it is used to make your classified experience safe and transparent."
        />
        <meta property="og:url" content="https://naijads.ng/privacy-policy" />
        <meta property="og:type" content="article" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'PrivacyPolicy',
            name: 'Privacy Policy – Naijads.ng',
            url: 'https://naijads.ng/privacy-policy',
            description:
              'This Privacy Policy describes how Naijads.ng handles your personal information and complies with Nigerian data protection regulations.',
            publisher: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              url: 'https://naijads.ng',
              logo: {
                '@type': 'ImageObject',
                url: 'https://naijads.ng/assets/Tayo.svg',
              },
            },
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>Privacy policy</h1>
          <p>
            At <strong>Naijads.ng</strong>, your privacy matters. This Privacy Policy explains how we collect, manage, and protect the information you share with us when
            using our website or services, in accordance with the <strong>Nigeria Data Protection Regulation (NDPR)</strong> and best practices in digital safety.
          </p>
        </div>

        <div className="info-block">
          <h3>Information we Collect</h3>
          <p>
            We may collect details like your name, email address, phone number, location, listings, and messages — only when you provide them voluntarily through forms,
            registration, or communication.
          </p>
        </div>

        <div className="info-block">
          <h3>Why we collect your Data</h3>
          <ul>
            <li>To power your ad listings and messages</li>
            <li>To respond to feedback and offer support</li>
            <li>To improve site functionality and usability</li>
            <li>To show relevant offers and alerts (when you opt in)</li>
            <li>To comply with legal obligations</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Cookies & Tracking</h3>
          <p>
            Naijads.ng uses cookies to keep your sessions active, monitor traffic, and improve your experience. You can manage cookie preferences in your browser at any
            time.
          </p>
        </div>

        <div className="info-block">
          <h3>Data security</h3>
          <p>
            We use secure hosting, encryption, and restricted access protocols to protect your information from unauthorized use or disclosure. Your data stays private and
            safe, as expected.
          </p>
        </div>

        <div className="info-block">
          <h3>When we share Data</h3>
          <ul>
            <li>With trusted tech partners (hosting, email services)</li>
            <li>Only when legally requested by Nigerian authorities</li>
            <li>With your permission — never without it</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Third-party Links</h3>
          <p>
            We may link to third-party sites (e.g., payment providers, ads). Their privacy policies are separate — we advise reading those before using such platforms.
          </p>
        </div>

        <div className="info-block">
          <h3>Your rights under NDPR</h3>
          <ul>
            <li>Request access to your personal data</li>
            <li>Ask for corrections or deletion of your data</li>
            <li>Withdraw consent for optional marketing</li>
          </ul>
          <p>
            To exercise your rights, kindly <a href="mailto:naijads.tech@gmail.com">email us</a>. We’ll respond within reasonable timeframes as per
            Nigerian law.
          </p>
        </div>

        <div className="info-block">
          <h3>Children’s privacy</h3>
          <p>
            Naijads.ng is intended for users age 18 and above. We do not knowingly collect information from minors. If such data is found, it will be deleted promptly.
          </p>
        </div>

        <div className="info-block">
          <h3>Policy updates</h3>
          <p>
            This Privacy Policy may change periodically to reflect law updates or platform improvements. We’ll publish updates here with clear effective dates.
          </p>
        </div>

        <div className="info-block">
          <h3>Contact us</h3>
          <p>
            Have questions, requests, or feedback about this Privacy Policy?<br />
            <strong>Email:</strong> <a href="mailto:naijads.tech@gmail.com">here</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
